import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import styles from './AboutPage.module.css';
import ChatWidget from './ChatWidget';
import SiteNav from './SiteNav';
import SiteFooter from './SiteFooter';

const hostname = window.location.hostname;
const IS_PERSIAN = hostname === 'potterhead.ir' || hostname === 'www.potterhead.ir';

const T = {
  fa: {
    dir: 'rtl',
    logo: 'جامعه پاترهدها',
    home: 'صفحه اصلی',
    title: 'مراحل بازی و داستان هاگوارتز',
    subtitle: 'این جامعه بر پایه مطالعه دقیق هر هفت جلد کتاب هری پاتر ساخته شده است.',
    introTitle: 'چرا این پروژه ساخته شد؟',
    introText: `جامعه پاترهدها یک تجربه تعاملی آنلاین است که دنیای هری پاتر را به زندگی واقعی می‌آورد.
هدف اصلی این است که هر خواننده‌ای بتواند خودش را در قالب یک دانش‌آموز هاگوارتز تصور کند، مسیر هفت‌ساله تحصیل را طی کند، و تجربه‌ای شخصی و منحصربه‌فرد داشته باشد.

تمام هفت جلد کتاب به‌دقت مطالعه شده و محتوای آن — از قیمت اقلام کوچه دیاگون تا وردهای سال هفتم — در پایگاه داده پروژه ثبت شده است. هر چند هفته بخش‌های جدیدی از کتاب در سایت پیاده‌سازی می‌شود.`,
    bookTitle: 'هر هفت جلد را خوانده‌ایم',
    bookText: 'هر ۷ جلد — ۴٬۱۸۷ صفحه — را خوانده‌ایم و هر جزئیاتی را که قابل پیاده‌سازی بود فهرست کرده‌ایم:',
    bookStats: [
      { icon: '📖', label: '۷ جلد کتاب', value: 'مطالعه‌شده' },
      { icon: '🪄', label: 'بیش از ۴۰ طلسم', value: 'سال‌به‌سال' },
      { icon: '💰', label: 'سیستم اقتصادی', value: 'گالیون / سیکل / نات' },
      { icon: '🏪', label: 'بیش از ۱۵ فروشگاه', value: 'کوچه دیاگون' },
      { icon: '🎓', label: '۷ سال تحصیل', value: 'هر سال یک فصل' },
      { icon: '🦉', label: 'بیش از ۲۰ مأموریت', value: 'در دست طراحی' },
    ],
    yearsTitle: 'مراحل هفت‌ساله',
    years: [
      {
        year: 'سال اول',
        status: 'در حال توسعه',
        statusClass: 'active',
        icon: '🌱',
        desc: 'ورود به هاگوارتز: گروه‌بندی، چوبدستی، پاترونوس، درخت مهارت پایه، آزمون‌های طلسم و تغییر شکل.',
        spells: ['وینگاردیوم لویوسا', 'آلوهومورا', 'پتری‌فیکوس توتالوس']
      },
      {
        year: 'سال دوم',
        status: 'برنامه‌ریزی‌شده',
        statusClass: 'planned',
        icon: '🌿',
        desc: 'کلوپ دوئل، گیاه‌شناسی پیشرفته، مدیریت مهرگیاه، و مسابقات کوئیدیچ.',
        spells: ['اکسپلیارموس', 'ریکتوسمپرا', 'فینیت اینکانتاتم']
      },
      {
        year: 'سال سوم',
        status: 'برنامه‌ریزی‌شده',
        statusClass: 'planned',
        icon: '🌲',
        desc: 'دفاع پیشرفته، مقابله با لولوخورخوره، سفر به هاگزمید، راه‌های مخفی قلعه.',
        spells: ['ریدیکولوس', 'اکسپکتو پاترونوم', 'دیسندیوم']
      },
      {
        year: 'سال چهارم',
        status: 'برنامه‌ریزی‌شده',
        statusClass: 'planned',
        icon: '🔥',
        desc: 'جام آتش، هزارتو، افسون‌های احضار و سپر، جام جهانی کوئیدیچ.',
        spells: ['اکسیو', 'استوپفای', 'پروتگو']
      },
      {
        year: 'سال پنجم',
        status: 'برنامه‌ریزی‌شده',
        statusClass: 'planned',
        icon: '⚔️',
        desc: 'ارتش دامبلدور، جادوهای غیرلفظی، آزمون‌های سمج (O.W.L.)، وزارت جادو.',
        spells: ['جادوی غیرلفظی', 'افسون ناپدید کردن', 'پروتگو']
      },
      {
        year: 'سال ششم',
        status: 'برنامه‌ریزی‌شده',
        statusClass: 'planned',
        icon: '🌑',
        desc: 'شاهزاده دورگه، غیب و ظاهر شدن، هورکراکس‌ها، جادوهای خطرناک.',
        spells: ['لویکورپوس', 'سکتوم‌سمپرا', 'آگوآمنتی']
      },
      {
        year: 'سال هفتم',
        status: 'برنامه‌ریزی‌شده',
        statusClass: 'planned',
        icon: '⚡',
        desc: 'نبرد هاگوارتز، محافظت از قلمرو، زنده کردن مجسمه‌ها، نبرد نهایی.',
        spells: ['پروتگو توتالوم', 'پی‌یرتوتوم لوکوموتور', 'کانفرینگو']
      }
    ],
    requestTitle: 'درخواست ویژگی جدید',
    requestDesc: 'اگر بخشی از کتاب هری پاتر را می‌شناسی که دوست داری در سایت پیاده‌سازی شود، اینجا درخواست بده. تیم توسعه درخواست‌ها را می‌بیند و بر اساس محبوبیت اضافه می‌کند.',
    fields: {
      name: 'نام شما (اختیاری)',
      email: 'ایمیل (اختیاری)',
      title: 'عنوان ویژگی *',
      description: 'توضیحات *',
      book: 'ارجاع به کتاب (اختیاری)',
      submit: 'ارسال درخواست',
      sending: 'در حال ارسال...',
      success: '✓ درخواستت ثبت شد! ممنون که به بزرگ‌تر شدن هاگوارتز کمک می‌کنی.',
      titlePlaceholder: 'مثلاً: بازی کوئیدیچ با دیگران',
      descPlaceholder: 'توضیح بده این ویژگی چیه و چرا باید اضافه بشه (حداقل ۲۰ حرف)',
      bookPlaceholder: 'مثلاً: کتاب ۳، فصل ۱۵'
    },
    footerHome: 'بازگشت به صفحه اصلی'
  },
  en: {
    dir: 'ltr',
    logo: 'Potterheads Community',
    home: 'Home',
    title: 'Game Journey & Hogwarts Story',
    subtitle: 'This community is built from a complete, detailed study of all seven Harry Potter books.',
    introTitle: 'Why was this project created?',
    introText: `Potterheads Community is an interactive online experience that brings the wizarding world to life.
The goal is for every reader to step into the shoes of a Hogwarts student — to walk the seven-year path and have a unique, personalized magical identity.

All seven books have been carefully studied, and their content — from Diagon Alley prices to seventh-year spells — has been catalogued in our database. New sections of the books are implemented on the platform every few weeks.`,
    bookTitle: 'The entire series has been read',
    bookText: 'We have read all 7 volumes and catalogued every implementable detail:',
    bookStats: [
      { icon: '📖', label: '7 Books', value: 'Fully studied' },
      { icon: '🪄', label: '40+ Spells', value: 'Year by year' },
      { icon: '💰', label: 'Economy system', value: 'Galleons / Sickles / Knuts' },
      { icon: '🏪', label: '15+ Shops', value: 'Diagon Alley' },
      { icon: '🎓', label: '7 School years', value: 'Each year a chapter' },
      { icon: '🦉', label: '20+ Missions', value: 'In design' },
    ],
    yearsTitle: 'The Seven-Year Journey',
    years: [
      {
        year: 'Year One',
        status: 'In development',
        statusClass: 'active',
        icon: '🌱',
        desc: 'Entering Hogwarts: Sorting, wand, Patronus, skill tree, Charms and Transfiguration.',
        spells: ['Wingardium Leviosa', 'Alohomora', 'Petrificus Totalus']
      },
      {
        year: 'Year Two',
        status: 'Planned',
        statusClass: 'planned',
        icon: '🌿',
        desc: 'Dueling Club, advanced Herbology, Mandrake management, Quidditch matches.',
        spells: ['Expelliarmus', 'Rictusempra', 'Finite Incantatem']
      },
      {
        year: 'Year Three',
        status: 'Planned',
        statusClass: 'planned',
        icon: '🌲',
        desc: 'Advanced Defense, Boggart encounter, Hogsmeade visits, secret passages.',
        spells: ['Riddikulus', 'Expecto Patronum', 'Dissendium']
      },
      {
        year: 'Year Four',
        status: 'Planned',
        statusClass: 'planned',
        icon: '🔥',
        desc: 'Goblet of Fire, maze challenge, Summoning & Shield charms, Quidditch World Cup.',
        spells: ['Accio', 'Stupefy', 'Protego']
      },
      {
        year: 'Year Five',
        status: 'Planned',
        statusClass: 'planned',
        icon: '⚔️',
        desc: "Dumbledore's Army, non-verbal magic, O.W.L. exams, Ministry of Magic.",
        spells: ['Non-verbal spells', 'Vanishing Spells', 'Protego']
      },
      {
        year: 'Year Six',
        status: 'Planned',
        statusClass: 'planned',
        icon: '🌑',
        desc: 'Half-Blood Prince, Apparition training, Horcrux hunt, dark magic.',
        spells: ['Levicorpus', 'Sectumsempra', 'Aguamenti']
      },
      {
        year: 'Year Seven',
        status: 'Planned',
        statusClass: 'planned',
        icon: '⚡',
        desc: 'Battle of Hogwarts, area protection, animating statues, final showdown.',
        spells: ['Protego Totalum', 'Piertotum Locomotor', 'Confringo']
      }
    ],
    requestTitle: 'Request a New Feature',
    requestDesc: 'Know something from the books you\'d love to see in the community? Submit a request — the team reviews all submissions and prioritises by popularity.',
    fields: {
      name: 'Your name (optional)',
      email: 'Email (optional)',
      title: 'Feature title *',
      description: 'Description *',
      book: 'Book reference (optional)',
      submit: 'Submit Request',
      sending: 'Sending...',
      success: '✓ Your request has been submitted! Thank you.',
      titlePlaceholder: 'e.g. Live Quidditch match with other players',
      descPlaceholder: 'Describe this feature and why it should be added (min 20 chars)',
      bookPlaceholder: 'e.g. Book 3, Chapter 15'
    },
    footerHome: 'Back to Home'
  }
};

function RequestForm() {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'fa';
  const t = T[lang] || T.en;

  const [form, setForm] = useState({ name: '', email: '', title: '', description: '', bookReference: '' });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.title.trim()) { setError(lang === 'fa' ? 'عنوان الزامی است.' : 'Title is required.'); return; }
    if (form.description.trim().length < 20) { setError(lang === 'fa' ? 'توضیحات باید حداقل ۲۰ حرف باشد.' : 'Description must be at least 20 characters.'); return; }

    setLoading(true);
    try {
      await axios.post('/api/feature-requests', {
        title: form.title.trim(),
        description: form.description.trim(),
        bookReference: form.bookReference.trim(),
        submitterName: form.name.trim(),
        submitterEmail: form.email.trim(),
        lang
      });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || (lang === 'fa' ? 'خطا در ارسال' : 'Submission failed'));
    } finally {
      setLoading(false);
    }
  };

  if (done) return <p className={styles.successMsg}>{t.fields.success}</p>;

  return (
    <form className={styles.requestForm} onSubmit={handleSubmit}>
      <div className={styles.formRow}>
        <input className={styles.input} name="name" placeholder={t.fields.name} value={form.name} onChange={handleChange} maxLength={100} />
        <input className={styles.input} name="email" type="email" placeholder={t.fields.email} value={form.email} onChange={handleChange} maxLength={200} />
      </div>
      <input className={styles.input} name="title" placeholder={t.fields.titlePlaceholder} value={form.title} onChange={handleChange} maxLength={300} required />
      <textarea className={styles.textarea} name="description" placeholder={t.fields.descPlaceholder} value={form.description} onChange={handleChange} rows={5} maxLength={5000} required />
      <input className={styles.input} name="bookReference" placeholder={t.fields.bookPlaceholder} value={form.bookReference} onChange={handleChange} maxLength={200} />
      {error && <p className={styles.errorMsg}>{error}</p>}
      <button className={styles.submitBtn} type="submit" disabled={loading}>
        {loading ? t.fields.sending : t.fields.submit}
      </button>
    </form>
  );
}

export default function AboutPage() {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'fa';
  const t = T[lang] || T.en;

  // محتوای قابل ویرایش از پنل ادمین (عنوان، مقدمه، آمار کتاب‌ها، مسیر هفت‌ساله،
  // درخواست ویژگی) — تا وقتی از سرور نرسیده از مقادیر پیش‌فرض هاردکد t استفاده
  // می‌شود تا صفحه خالی نماند (همان الگوی LandingPage.jsx).
  const [content, setContent] = useState(t);

  useEffect(() => {
    setContent(t);
    let mounted = true;
    axios.get(`/api/about?_=${Date.now()}`)
      .then((res) => {
        const fetched = res.data?.content?.[lang];
        if (mounted && fetched) {
          setContent((prev) => ({ ...prev, ...fetched }));
        }
      })
      .catch(() => {}); // در صورت خطا، مقادیر پیش‌فرض هاردکد باقی می‌مانند
    return () => { mounted = false; };
  }, [lang]);

  return (
    <div className={styles.page} dir={t.dir}>
      {/* NAV */}
      <SiteNav />

      {/* HERO */}
      <section className={styles.hero}>
        <div className={styles.heroContent}>
          <h1>{content.title}</h1>
          <p className={styles.subtitle}>{content.subtitle}</p>
        </div>
        <div className={styles.heroGlow} />
      </section>

      {/* INTRO */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>{content.introTitle}</h2>
          <div className={styles.introText}>
            {content.introText.split('\n').map((line, i) => line.trim() ? <p key={i}>{line}</p> : <br key={i} />)}
          </div>
        </div>
      </section>

      {/* BOOK STATS */}
      <section className={`${styles.section} ${styles.darkSection}`}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>{content.bookTitle}</h2>
          <p className={styles.sectionDesc}>{content.bookText}</p>
          <div className={styles.statsGrid}>
            {content.bookStats.map((s, i) => (
              <div key={i} className={styles.statCard}>
                {s.image ? (
                  <img
                    // کلید = آدرس تصویر تا با تغییر src (بعد از رسیدن پاسخ /api/about)
                    // یک <img> کاملاً تازه ساخته شود، نه همان تگ قبلی با style قدیمی
                    key={s.image}
                    src={s.image}
                    alt={s.label}
                    style={{
                      width: s.imageWidth ? `${s.imageWidth}px` : '32px',
                      height: s.imageHeight ? `${s.imageHeight}px` : '32px',
                      objectFit: 'contain'
                    }}
                    onError={(e) => { e.currentTarget.style.opacity = 0.25; }}
                  />
                ) : (
                  <span className={styles.statIcon}>{s.icon}</span>
                )}
                <strong className={styles.statValue}>{s.value}</strong>
                <span className={styles.statLabel}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEVEN YEARS TIMELINE */}
      <section className={styles.section}>
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>{content.yearsTitle}</h2>
          <div className={styles.timeline}>
            {content.years.map((yr, i) => (
              <div key={i} className={`${styles.timelineItem} ${i % 2 === 0 ? styles.left : styles.right}`}>
                <div className={styles.timelineDot}>
                  {yr.image ? (
                    <img
                      key={yr.image}
                      src={yr.image}
                      alt={yr.year}
                      style={{
                        width: yr.imageWidth ? `${yr.imageWidth}px` : '32px',
                        height: yr.imageHeight ? `${yr.imageHeight}px` : '32px',
                        objectFit: 'contain',
                        borderRadius: '50%'
                      }}
                      onError={(e) => { e.currentTarget.style.opacity = 0.25; }}
                    />
                  ) : yr.icon}
                </div>
                <div className={styles.timelineCard}>
                  <div className={styles.timelineHeader}>
                    <h3>{yr.year}</h3>
                    <span className={`${styles.statusBadge} ${styles[yr.statusClass]}`}>{yr.status}</span>
                  </div>
                  <p className={styles.timelineDesc}>{yr.desc}</p>
                  <div className={styles.spellList}>
                    {(yr.spells || []).map((sp, j) => <span key={j} className={styles.spellTag}>✨ {sp}</span>)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURE REQUEST */}
      <section className={`${styles.section} ${styles.darkSection}`} id="request">
        <div className={styles.container}>
          <h2 className={styles.sectionTitle}>{content.requestTitle}</h2>
          <p className={styles.sectionDesc}>{content.requestDesc}</p>
          <RequestForm />
        </div>
      </section>

      {/* FOOTER */}
      <SiteFooter />

      <ChatWidget />
    </div>
  );
}
